import React, {useState, useEffect} from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { createMuiTheme, ThemeProvider, withStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import axios from 'axios'

const MAX_AGENT_CONTEXT_LENGTH = 2000

const theme = createMuiTheme({
    palette:{
        primary: {
            main:"#0b1f82"
        },
        secondary: {
            main: "#FF0000"
        }
    }
});


const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

function AgentContextDialog(props) {
    const { t } = useTranslation();

    let {onClose, ruleDefinition, currentAgentContext, onSaved} = props

    const [agentContext, setAgentContext] = useState(currentAgentContext || "")
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)

    useEffect(() => {
        if (props.open) {
            setAgentContext(currentAgentContext || "")
            setErrorMessage(null)
        }
    }, [props.open, currentAgentContext])

    const validateAllValues = () => {
        return agentContext.length <= MAX_AGENT_CONTEXT_LENGTH
    }

    const handleSaveAgentContext = () => {
        let normalizedAgentContext = agentContext.trim().length > 0 ? agentContext.trim() : null
        setIsLoading(true)
        setErrorMessage(null)
        let payload = {
            agent_context: normalizedAgentContext
        }
        let headersRequest = {
            headers: {
                "COMPANY-KEY": ruleDefinition.company_key || "",
            },
        }
        let url = '/dash/rule_engine/company_event/' + ruleDefinition.event_type + "/agent_context?environment=" + ruleDefinition.environment
        axios.put(url, payload, headersRequest).then(response => {
                setIsLoading(false)
                onSaved(normalizedAgentContext)
                onClose()
            }).catch(error => {
                setIsLoading(false)
                setErrorMessage(t("Não foi possível salvar o contexto do assistente de IA"))
            });
    }

    const handleClose = () => {
        onClose()
    }


    return (
        <Dialog
            open={props.open}
            onClose={handleClose}
            disableBackdropClick
            disableEscapeKeyDown
            keepMounted={false}
        >
            <DialogTitle
                className={['blueText', "subtitleSize"].join(" ")}
                onClose={handleClose}
            >
                {t("Contexto do Assistente de IA")}
            </DialogTitle>
            <DialogContent >
                <ThemeProvider theme={theme}>
                <div style={{padding:"20px", display:"flex", flexDirection:"column", marginBottom:"30px", width:"400px"}}>
                    {isLoading
                    ?
                    <CircularProgress style={{margin:"auto"}}/>
                    :
                    <React.Fragment>
                    <div className={["normalText", "normalMediumSize"].join(" ")} style={{marginBottom:"10px"}}>
                        {t("Descreva o contexto de negócio deste evento para o assistente de regras gerar melhores explicações e sugestões.")}
                    </div>
                    <div className={["normalText", "normalMediumSize", "bold"].join(" ")} style={{marginBottom:"10px"}}>
                        {t("Atenção: este contexto influencia a forma como o assistente interpreta TODAS as regras desta esteira, não apenas esta regra.")}
                    </div>
                    <div className="internalCardContainer">
                        <TextField
                            error={!validateAllValues()}
                            helperText={agentContext.length + "/" + MAX_AGENT_CONTEXT_LENGTH}
                            label={t("Contexto do Assistente de IA")}
                            style={{textAlign:"center"}}
                            className="filterTextbox"
                            size="small" fullWidth
                            multiline
                            rows={6}
                            value={agentContext}
                            onChange={(e) => setAgentContext(e.target.value)}
                            autoFocus
                        />
                    </div>
                    {errorMessage ?
                    <div className={["normalText", "normalMediumSize", "redText"].join(" ")} style={{marginBottom:"10px"}}>
                        {errorMessage}
                    </div>
                    : null}
                    <div className="internalCardContainer" style={{display:"flex", marginTop: "10px"}}>
                        <div
                            className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                            style={{width:"120px"}}
                            onClick={handleClose}
                        >
                           {t("discard")}
                        </div>
                        <div
                            className={
                                validateAllValues()
                                ?
                                ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                                :
                                ["button", "standard", "normalText", "normalMediumSize","disabled"].join(" ")}
                            style={{width:"120px"}}
                            onClick={validateAllValues() ? () => handleSaveAgentContext() : null}
                        >
                            {t("save")}
                        </div>
                    </div>
                    </React.Fragment>
                    }
                </div>
                </ThemeProvider>
            </DialogContent>
        </Dialog>
    )
}

export default AgentContextDialog
